module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniffspot-app-store-logo-256.5340ea9a1db69bf0.png"+" 256w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniffspot-app-store-logo-256.5340ea9a1db69bf0.png",width: 256,height: 256}],
        src: "https://static.sniffspot.com/packs/img/sniffspot-app-store-logo-256.5340ea9a1db69bf0.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniffspot-app-store-logo-256.5340ea9a1db69bf0.png"},
        
        width: 256,
        height: 256
      }